module.exports = __webpack_public_path__ + "static/media/photolab_mobile.110f720a.png";